import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Button } from '@mui/material';
import { useSnackbar } from 'notistack';
import GroupAPI from 'api/GroupAPI';
import { IKeycloakTeam } from 'pages/superAdmin/TeamAccess';

const JoinTeam = (props: {curTeam: any, curUser: any}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [ disabled, setDisabled ] = useState(false);
  const history = useHistory();

  useEffect(() => {
    props.curUser?.teams?.map((team: IKeycloakTeam) => {
      if (team.name === props.curTeam?.name) {
        setDisabled(true);
      }
    });
  }, []);

  const handleJoinTeam = async() => {
    const resp = await GroupAPI.assignGroupToUser(props.curTeam.id, props.curUser.basics.id);
    if (resp?.success) {
      enqueueSnackbar('Successfully joined team. Logout and log back in to see changes', { variant: 'success' });
      setDisabled(true);
      history.push('/team-access');
    } else{
      const err_text = `Error joining team: ${resp?.result}`;
      enqueueSnackbar(err_text, { variant: 'error' });
    }
  };

  return (
    <div>
      <Typography className='text-white' variant='h6' component='h2'>
        Click Button Below to Join {props.curTeam?.name}
      </Typography>
      <br />
      <Button disabled={disabled} onClick={handleJoinTeam} variant='contained' className='Theme-Btn' type='submit'>
        Join {props.curTeam?.name}
      </Button>
      {disabled &&
        <Typography className='text-white' variant='h6' component='h2'>
          You are already in this team
        </Typography>
      }
    </div>
  );
};

export default JoinTeam;
